import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SessionProvider } from './context/SessionContext';
import { AuthProvider } from './context/AuthContext';
import ErrorToastWrapper from './components/ErrorToastWrapper';
import ConnectionStatus from './components/ConnectionStatus';
import CatalogPage from './pages/CatalogPage';
import CreateSessionPage from './pages/CreateSessionPage';
import SessionLobbyPage from './pages/SessionLobbyPage';
import JoinSessionPage from './pages/JoinSessionPage';
import SwipePage from './pages/SwipePage';
import ResultsPage from './pages/ResultsPage';
import ProfilePage from './pages/ProfilePage';
import PreferencesSetupPage from './pages/PreferencesSetupPage';

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <SessionProvider>
          <ConnectionStatus />
          <ErrorToastWrapper />
          <Routes>
            <Route path="/" element={<CatalogPage />} />
            <Route path="/create" element={<CreateSessionPage />} />
            <Route path="/session/create" element={<CreateSessionPage />} />
            <Route path="/session/:sessionId/lobby" element={<SessionLobbyPage />} />
            <Route path="/session/:sessionId/join" element={<JoinSessionPage />} />
            <Route path="/session/:sessionId/swipe" element={<SwipePage />} />
            <Route path="/session/:sessionId/results" element={<ResultsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/preferences/setup" element={<PreferencesSetupPage />} />
          </Routes>
        </SessionProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
